import {
    OBTENER_LLAVES,
    GET_CONFIG_FORM88
} from '../types';


export default function visarRendicionRecuperoReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORM88:
            return { ...state, cfg_form88:action.payload }
    
        default:
            return state
    }
}